import { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
// material
import { experimentalStyled as styled } from '@material-ui/core/styles';
//
import DashboardNavbar from './DashboardNavbar';
import DashboardSidebar from './DashboardSidebar';
import MobileBottomNavBar from 'src/components/MobileBottomNavBar';
import AnnouncementBanner from 'src/components/AnnouncementBanner';
import { useMediaQuery, useTheme } from '@material-ui/core';
import useAuth from 'src/hooks/useAuth';

// ----------------------------------------------------------------------

const APP_BAR_MOBILE = 64;
const APP_BAR_DESKTOP = 92;

const RootStyle = styled('div')({
  display: 'flex',
  minHeight: '100%',
  overflow: 'hidden'
});

const MainStyle = styled('div')(({ theme, selectVehicle, isMobile }) => ({
  flexGrow: 1,
  overflow: 'auto',
  minHeight: '100%',
  paddingTop: isMobile && selectVehicle ? 0 : APP_BAR_MOBILE + 24,
  paddingBottom: `calc(${theme.spacing(10)} + env(safe-area-inset-bottom, 0px))`,
  [theme.breakpoints.up('lg')]: {
    paddingTop: APP_BAR_DESKTOP + 24,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2)
  }
}));

// ----------------------------------------------------------------------

export default function DashboardLayout() {
  const [open, setOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const { user } = useAuth();
  const { pathname } = useLocation();
  const selectVehicle = pathname === '/dashboard/select-vehicle';
  const userType = Number(user?.user_type);
  const hideBanner = userType === 2 || userType === 3 || userType === 7; // customer, driver, passenger
  return (
    <RootStyle>
      {!(isMobile && selectVehicle) && (
        <DashboardNavbar onOpenSidebar={() => setOpen(true)} />
      )}
      {!isMobile && (<DashboardSidebar isOpenSidebar={open} onCloseSidebar={() => setOpen(false)} />)}
      <MainStyle selectVehicle={selectVehicle} isMobile={isMobile}>
        {/* {!hideBanner && <AnnouncementBanner variant="dashboard" />} */}
        <Outlet />
        {isMobile && (<MobileBottomNavBar />)}
      </MainStyle>
    </RootStyle>
  );
}
